import { render, staticRenderFns } from "./scrollLoad.vue?vue&type=template&id=a25831d2&scoped=true&"
import script from "./scrollLoad.vue?vue&type=script&lang=js&"
export * from "./scrollLoad.vue?vue&type=script&lang=js&"
import style0 from "./scrollLoad.vue?vue&type=style&index=0&id=a25831d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25831d2",
  null
  
)

export default component.exports